import { render } from "./ConfirmationPage.vue?vue&type=template&id=128e0fc8&scoped=true"
import script from "./ConfirmationPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationPage.vue?vue&type=script&lang=js"

import "./ConfirmationPage.vue?vue&type=style&index=0&id=128e0fc8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-128e0fc8"

export default script